import AlternativesAssetPosition from './alternatives-asset-position';
import AlternativesAssetPositionDetails from './alternatives-asset-position-details';

import assetPositionsFactory from '../positions/asset-positions-factory';

export default assetPositionsFactory({
  assetCategory: 'alternatives',
  RowComponent: AlternativesAssetPosition,
  ExpandedRowComponent: AlternativesAssetPositionDetails,
});
